//import libraries
import { Component, OnInit, AfterViewInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppPermissions } from '../../../../constants/app-permission';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { AuthService } from '../../../../services/auth.service';
import { GeneralService } from '../../../../services/general.service';
import { NotificationService } from '../../../../services/notification.service';
import { ConfirmationDialogService } from '../../../general/modals/confirmation/confirmation.service';

import { CustomersService } from '../../../../services/customers.service';
import { ConsultancyService } from '../../../../services/consultancy.service';

//import classes
import {
  UserMangActionAddEditIn, UserMangActionAddEditOut, UserMangActionUpdateOut, SubUserList
} from '../../../../classes/profile.model';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';
import { ValidateUniqueEmail } from '../../../../validators/uniqueEmail.validator';
import { EmployeeService } from '../../../../services/employee.service';

declare var $: any;

@Component({
  selector: 'app-consultancy_create',
  templateUrl: './consultancy_create.component.html',
  styleUrls: ['./consultancy_create.component.css']
})
export class CreateConsultancyComponent implements OnInit, AfterViewInit {

  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;

  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  maintenance_plans: any;
  app_maintenance_plans: any;
  app_emp_id: any;
  lang: any;
  generalLang: any;
  record: any;
  mode: string;
  courseType: any;
  contractType: any;

  imageLink: any;
  data: any;
  skills_places: any;
  skills_places1: any;
  course: any;
  course_m: any;
  edit_data: any;
  const_type_data: any;
  id: any;
  contract_type: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  edit_id:string
  deleted_ids:Array<any> = []

  public addresses: any[] = [{
    id: 1,
    address: '',
    street: '',
    city: '',
    country: ''
  }];

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private notificationService: NotificationService,
    private consultancyService: ConsultancyService,
    private customersService: CustomersService,

    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private router: Router) { }

  ngOnInit() {
    //fetch data
    this.data    = this.route.snapshot.data['data'];
    this.edit_id = this.route.snapshot.paramMap.get('id');
    console.log(this.edit_id)
    //tab1 actions
    this.getData();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  addAddress() {
    this.addresses.push({
      id: this.addresses.length + 1,
      address: '',
      street: '',
      city: '',
      country: ''
    });
  }

  removeAddress(i: number) {
    this.addresses.splice(i, 1);
  }

  ngAfterViewInit(): void {

    let tab = this.route.snapshot.paramMap.get('tab');

    if (tab)
      $('.nav-tabs a[href="#settingsTab"]').tab('show');

  }





  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      code: ['', [Validators.required]],
      customer: ['', [Validators.required]],
      contract_type: [''],
      starting_date: [''],
      meeting_year: [''],
      amount: [''],
      attachments: (this.edit_id )? this.formBuilder.array([]) :this.formBuilder.array([this.newAttachment1()]),
      attachments_uploaded: this.formBuilder.array([]),
      cid: '',
      delete_ids: [''],
      submit: 'update',
    });

    setTimeout(() => this.fileDesign(), 10);

    setTimeout(() => this.fileDesign(), 10);

    this.attachments().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

    this.attachments_uploaded().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });


  }



  FormBuildUpdate(): void {
      this.createForm.patchValue({ 
        code: this.edit_data.consultancy_code,
        customer: this.edit_data.customer_id,
        cid: this.edit_data.consultancyId,
        submit: 'update',
      });
    if(this.edit_id && this.const_type_data.length <= 0){
      this.attachments().push(this.newAttachment1());
    }else{
        for(var index in this.const_type_data){
          var tempObj = {
            "contract_type": [this.const_type_data[index].contract_type],
            "starting_date": [this.const_type_data[index].starting_date],
            "meeting_year": [this.const_type_data[index].meeting_year],
            "amount": [this.const_type_data[index].amount],
            "contract_file":[this.const_type_data[index].contract_file],
            "consultancy_id":[this.const_type_data[index].consultancy_id],
            "consultancy_typeId":[this.const_type_data[index].consultancy_typeId],
          }
          var image = this.const_type_data[index].contract_file
          this.attachments_uploaded().push(new FormControl(image.split('/').pop())  )
    
          this.attachments().push(this.formBuilder.group(tempObj));
        }
    }



  }


  attachments(): FormArray {
    return this.createForm.get('attachments') as FormArray;
  };

  newAttachment1(): FormGroup {
    return this.formBuilder.group({
      contract_type: [''],
      starting_date: [''],
      meeting_year: [''],
      amount: [''],
      link: ['']
    });
  }


  addAttachment(): void {
    this.attachments().push(this.newAttachment1());
  }

  removeAttachment(i: number) {
    if(confirm("Are you sure to delete")) {
      console.log(i)
      this.deleted_ids.push(this.const_type_data[i].consultancy_typeId)
      console.log(this.deleted_ids)
      console.log(this.const_type_data[i].consultancy_typeId)
      this.createForm.patchValue({
        "delete_ids":this.deleted_ids.join(",")
      })
      this.attachments().removeAt(i);
    }    
  }

  removeFile(i: number) {
    if(confirm("Are you sure to delete")) {
      if(this.edit_id){
        document.getElementById("consultancy-img-"+i).setAttribute('value',"");
        console.log(this.attachments())
        console.log(this.attachments().at(i))
        this.attachments().at(i).get("contract_file").setValue("")
        this.const_type_data[i].contract_file = ""
      }else{
        document.getElementById("consultancy-img-"+i).setAttribute('value',"");
        console.log(this.attachments())
        console.log(this.attachments().at(i))
        this.attachments().at(i).get("link").setValue("")
      }

    }    
  }

  attachments_uploaded(): FormArray {
    return this.createForm.get('attachments_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.attachments_uploaded().removeAt(i);
  }


  public selectAttachment1(event: any, index) {
    console.log(event)
    console.log(this.createForm.value.attachments)
    // this.createForm.value.attachments[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        let result = { 'name': file.name, 'image': reader.result }
        this.createForm.value.attachments[index].link = { 'name': file.name, 'image': reader.result };

        document.getElementById("consultancy-img-"+index).setAttribute('value',JSON.stringify(result));
        this.attachments().at(index).get("link").setValue(result)
        console.log("========= Render =======")
        console.log(this.attachments().at(index).get("link").setValue(result))
      };
    }

  }


  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }



  onSubmit() {

    this.createFormSubmitted = true;

    // console.log(this.createForm.invalid); 
    if (this.createForm.invalid)
      return;

    // console.log('test12'); return false;

    this.consultancyService.updateConsultancy(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);

          // if (res.action == 'insert') {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.CONSULTANCY]);
              });
              
        }
        else {
          this.generalService.notify_msg('error', res.data);
        }

      }
    );

  }


  getData() {
    // this.lang = this.notificationService.GeneralGetLangData(this.data);
    this.route.params.subscribe(params => {
      this.id = params.id;

      if (this.id != undefined) {
        this.consultancyService.ConsultancyEdit(this.id)
          .subscribe(
            (res) => {

              // console.log(res); return false;
              this.lang = this.consultancyService.listLang(res);
     
              this.edit_data = res.data.edit_data;
              this.const_type_data = res.data.const_type_data;
              this.modalTitle = this.lang.editConsultancy;
              this.contract_type = res.data.contract_type;

              //  this.attachments = this.const_type_data;

              this.contractType = [
                { value: this.lang.RSPP, text: this.lang.RSPP },
                { value: this.lang.DT, text: this.lang.DT },
                { value: this.lang.QLT, text: this.lang.QLT },
                { value: this.lang.SIC, text: this.lang.SIC },
                { value: this.lang.ODV, text: this.lang.ODV },
                { value: this.lang.Other, text: this.lang.Other },
              ];

              this.createFormErrorMsg = {
                'code': [{ type: 'required', message: this.lang.requiredField }],
                'customer': [{ type: 'required', message: this.lang.requiredField }],
              }
              this.FormBuildUpdate();
            });
        this.FormBuild();

      }
      else {
        this.consultancyService.getConsultancyList()
          .subscribe(
            (res) => {
              this.lang = this.consultancyService.listLang(res);
              this.modalTitle = this.lang.createnew;
              this.contract_type = res.data.contract_type;


              this.contractType = [
                { value: this.lang.RSPP, text: this.lang.RSPP },
                { value: this.lang.DT, text: this.lang.DT },
                { value: this.lang.QLT, text: this.lang.QLT },
                { value: this.lang.SIC, text: this.lang.SIC },
                { value: this.lang.ODV, text: this.lang.ODV },
                { value: this.lang.Other, text: this.lang.Other },
              ];


              this.createFormErrorMsg = {
                'code': [{ type: 'required', message: this.lang.requiredField }],
                'customer': [{ type: 'required', message: this.lang.requiredField }],
                // 'contract_type': [{ type: 'required', message: this.lang.requiredField }],
                // 'starting_date': [{ type: 'required', message: this.lang.requiredField }],
                // 'meeting_year': [{ type: 'required', message: this.lang.requiredField }],
                // 'amount': [{ type: 'required', message: this.lang.requiredField }],
              }

            });

        this.FormBuild();

      }


    });



  }

  logValue(){
    console.log("========== Submit Success =======")
    console.log(this.addresses)
  }
}
